import { useCallback, useRef, useState } from "react";

function createUseStorage(storage) {
  // TODO: refresh consumers on change
  return (key, initialValue) => {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
      if (typeof window === "undefined") {
        return initialValue;
      }
      try {
        // Get from local storage by key
        const item = storage.getItem(key);
        // Parse stored json or if none return initialValue
        return item ? JSON.parse(item) : initialValue;
      } catch (error) {
        // If error also return initialValue
        console.log(error);
        return initialValue;
      }
    });
    const storedValueRef = useRef(storedValue);
    storedValueRef.current = storedValue;
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to *Storage.
    const setValue = useCallback(
      (value) => {
        try {
          // Allow value to be a function so we have same API as useState
          const valueToStore =
            value instanceof Function ? value(storedValueRef.current) : value;
          // Save state
          setStoredValue(valueToStore);
          // Save to local storage
          if (typeof window !== "undefined") {
            storage.setItem(key, JSON.stringify(valueToStore));
          }
        } catch (error) {
          // A more advanced implementation would handle the error case
          console.log(error);
        }
      },
      [key],
    );

    return [storedValue, setValue];
  };
}

export const useLocalStorage = createUseStorage(window.localStorage);
export const useSessionStorage = createUseStorage(window.sessionStorage);
